import { connect } from 'react-redux'

import ProjectsLayoutTen from 'components/hub-page/views/sections/projects/layouts/ten'

const mapStateToProps = (state, ownProps) => ({
  data: state.hubPageRevision.revision.sections[ownProps.sectionId].meta.autoAddProjects
    ? ownProps.projects
    : state.hubPageRevision.revision.sections[ownProps.sectionId].data,
  meta: state.hubPageRevision.revision.sections[ownProps.sectionId].meta,
  theme: state.hubPageRevision.revision.sections[ownProps.sectionId].theme,
  dataTestId: 'participant-hubs-views-projects-section-layout-ten'
})

export default connect(mapStateToProps)(ProjectsLayoutTen)
